import React, { memo } from 'react';
import NavButton from '../../../common/nav-button/NavButton';
import { useTranslation } from 'react-i18next';
import MIcon from '../../../common/m-icon/MIcon';
import { useDispatch } from 'react-redux';
import { dropFilter } from '@reducers//filterSlice.js';
import { LIBRARY_VIEW_FILTER_NAME } from '@views/Publications/Publications';
import { USERS_VIEW_FILTER_NAME } from '@views/Users/Users';
import { useLocation } from 'react-router-dom';

function NavigationPanel({ toggle, isAuth, role, isOpen, ...props }) {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const path = useLocation().pathname;
    const canManageUsers = role === 'editor_superadmin' || role === 'editor_admin';

    const onClick = (clearFilter) => {
        if (toggle) {
            toggle();
        }
        if (clearFilter) {
            dispatch(dropFilter({ filterName: clearFilter }));
        }
    };

    return (
      <>
          {
            isAuth && canManageUsers && (
              <>
                  <NavButton to={"users"}
                             className={`mr-2 ${path.startsWith('/user') && "navActive-editor"} btn-secondary-black flex flex-row`}
                             onClick={() => onClick(USERS_VIEW_FILTER_NAME)}
                  >
                      <MIcon
                        type={'users'}
                        className={`text-black cursor-pointer mr-2`}
                      />
                        Пользователи
                  </NavButton>
                  <NavButton to={"publications"}
                             className={`mr-2 ${path.startsWith('/publication') && "navActive-editor"} btn-secondary-black flex flex-row`}
                             onClick={() => onClick(LIBRARY_VIEW_FILTER_NAME)}
                  >
                      <MIcon
                        type={'schools'}
                        className={`text-black cursor-pointer mr-2`}
                      />
                      Издания
                  </NavButton>
              </>
            )
          }

          {isAuth && !canManageUsers && (
              <>
                  <NavButton to={"publications"}
                             className={`mr-2 ${path.startsWith('/publication') && "navActive-editor"} btn-secondary-black flex flex-row`}
                             onClick={() => onClick(LIBRARY_VIEW_FILTER_NAME)}
                  >
                      <MIcon
                        type={'schools'}
                        className={`text-black cursor-pointer mr-2`}
                      />
                      Издания
                  </NavButton>
              </>
            )
          }
      </>
    );
}

export default memo(NavigationPanel);
